"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
var _lodash = require("lodash");
var _mobx = require("mobx");
var _serializr = require("serializr");
var _concept_basic = _interopRequireDefault(require("./concept_basic"));
var _conjugated_verb_string = _interopRequireDefault(require("./conjugated_verb_string"));
var _level = _interopRequireDefault(require("./level"));
var _root_model = _interopRequireDefault(require("./root_model"));
var _source = _interopRequireDefault(require("./source"));
var _synonym_association = _interopRequireDefault(require("./synonym_association"));
var _target = _interopRequireDefault(require("./target"));
var _translation_basic = _interopRequireDefault(require("./translation_basic"));
var _translation_source = _interopRequireDefault(require("./translation_source"));
var _user = _interopRequireDefault(require("./user"));
var _word_structure = _interopRequireDefault(require("./word_structure"));
var _word_type = _interopRequireDefault(require("./word_type"));
var _worksheet_basic = _interopRequireDefault(require("./worksheet_basic"));
var _meaning = _interopRequireDefault(require("./meaning"));
var _serializer_helpers = require("./utils/serializer_helpers");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81, _descriptor82, _descriptor83, _descriptor84, _descriptor85, _descriptor86, _descriptor87, _descriptor88, _descriptor89, _descriptor90, _descriptor91, _descriptor92, _descriptor93, _descriptor94, _descriptor95, _descriptor96, _descriptor97, _descriptor98, _descriptor99, _descriptor100, _descriptor101, _descriptor102, _descriptor103, _descriptor104, _descriptor105, _descriptor106, _descriptor107, _descriptor108, _descriptor109, _descriptor110, _descriptor111, _descriptor112, _descriptor113, _descriptor114, _descriptor115, _descriptor116, _descriptor117, _descriptor118, _descriptor119, _descriptor120, _descriptor121, _descriptor122, _descriptor123, _descriptor124, _descriptor125, _descriptor126, _descriptor127, _descriptor128, _descriptor129, _descriptor130, _descriptor131; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var Word = (_dec = (0, _serializr.serializable)((0, _serializr.custom)(function (item) {
  return item;
}, function (item) {
  return item;
})), _dec2 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec3 = (0, _serializr.serializable)((0, _serializer_helpers.staticDateDecoratorOrNull)()), _dec4 = (0, _serializr.serializable)((0, _serializr.object)(_target["default"])), _dec5 = (0, _serializr.serializable)((0, _serializr.object)(_level["default"])), _dec6 = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec7 = (0, _serializr.serializable)((0, _serializr.object)(_translation_basic["default"])), _dec8 = (0, _serializr.serializable)((0, _serializr.object)(_translation_basic["default"])), _dec9 = (0, _serializr.serializable)((0, _serializr.object)(_translation_basic["default"])), _dec0 = (0, _serializr.serializable)((0, _serializr.object)(_translation_basic["default"])), _dec1 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_basic["default"]))), _dec10 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_basic["default"]))), _dec11 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_conjugated_verb_string["default"]))), _dec12 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_basic["default"]))), _dec13 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_concept_basic["default"]))), _dec14 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_source["default"]))), _dec15 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_word_structure["default"]))), _dec16 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_basic["default"]))), _dec17 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_synonym_association["default"]))), _dec18 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_basic["default"]))), _dec19 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_basic["default"]))), _dec20 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_source["default"]))), _dec21 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_translation_source["default"]))), _dec22 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_worksheet_basic["default"]))), _dec23 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_meaning["default"]))), _dec24 = (0, _serializr.serializable)((0, _serializr.object)(_word_type["default"])), _dec25 = (0, _serializr.serializable)((0, _serializr.object)(_word_type["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function Word() {
    var _this;
    _classCallCheck(this, Word);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Word, [].concat(args));
    // reactive
    _initializerDefineProperty(_this, "sentences", _descriptor, _this);
    _initializerDefineProperty(_this, "originalDeckId", _descriptor2, _this);
    _initializerDefineProperty(_this, "selectedDeckId", _descriptor3, _this);
    // static
    _initializerDefineProperty(_this, "id", _descriptor4, _this);
    _initializerDefineProperty(_this, "wordScope", _descriptor5, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor6, _this);
    _initializerDefineProperty(_this, "alternateGenders", _descriptor7, _this);
    _initializerDefineProperty(_this, "hideFromGenderTrainer", _descriptor8, _this);
    _initializerDefineProperty(_this, "hideFromPluralTrainer", _descriptor9, _this);
    _initializerDefineProperty(_this, "hideFromSynonymTrainer", _descriptor0, _this);
    _initializerDefineProperty(_this, "hideFromConjugationTrainer", _descriptor1, _this);
    _initializerDefineProperty(_this, "hideFromCaseTrainer", _descriptor10, _this);
    _initializerDefineProperty(_this, "hideReason", _descriptor11, _this);
    _initializerDefineProperty(_this, "sentencesCount", _descriptor12, _this);
    _initializerDefineProperty(_this, "hasSentences", _descriptor13, _this);
    _initializerDefineProperty(_this, "wordAssociationCount", _descriptor14, _this);
    _initializerDefineProperty(_this, "maxFrequencyRanking", _descriptor15, _this);
    _initializerDefineProperty(_this, "gender", _descriptor16, _this);
    _initializerDefineProperty(_this, "plural", _descriptor17, _this);
    _initializerDefineProperty(_this, "wordTypeId", _descriptor18, _this);
    _initializerDefineProperty(_this, "rootWordTypeId", _descriptor19, _this);
    _initializerDefineProperty(_this, "blankSource", _descriptor20, _this);
    _initializerDefineProperty(_this, "levelId", _descriptor21, _this);
    _initializerDefineProperty(_this, "label", _descriptor22, _this);
    _initializerDefineProperty(_this, "targetText", _descriptor23, _this);
    _initializerDefineProperty(_this, "alternateTargetText", _descriptor24, _this);
    _initializerDefineProperty(_this, "targetId", _descriptor25, _this);
    _initializerDefineProperty(_this, "inlineTargetText", _descriptor26, _this);
    _initializerDefineProperty(_this, "autoLevel", _descriptor27, _this);
    _initializerDefineProperty(_this, "wordAssociationId", _descriptor28, _this);
    _initializerDefineProperty(_this, "ignoreAutoLevel", _descriptor29, _this);
    _initializerDefineProperty(_this, "simple", _descriptor30, _this);
    _initializerDefineProperty(_this, "root", _descriptor31, _this);
    _initializerDefineProperty(_this, "isPrefix", _descriptor32, _this);
    _initializerDefineProperty(_this, "isStem", _descriptor33, _this);
    _initializerDefineProperty(_this, "isDate", _descriptor34, _this);
    _initializerDefineProperty(_this, "rootId", _descriptor35, _this);
    _initializerDefineProperty(_this, "excludeFromPublicLists", _descriptor36, _this);
    _initializerDefineProperty(_this, "excludeAsPluralForm", _descriptor37, _this);
    _initializerDefineProperty(_this, "sourcesCount", _descriptor38, _this);
    _initializerDefineProperty(_this, "enSourcesCount", _descriptor39, _this);
    _initializerDefineProperty(_this, "cardsCount", _descriptor40, _this);
    _initializerDefineProperty(_this, "noPlural", _descriptor41, _this);
    _initializerDefineProperty(_this, "pendingApproval", _descriptor42, _this);
    _initializerDefineProperty(_this, "submittedById", _descriptor43, _this);
    _initializerDefineProperty(_this, "commentsCount", _descriptor44, _this);
    _initializerDefineProperty(_this, "forumThreadId", _descriptor45, _this);
    _initializerDefineProperty(_this, "rootWordId", _descriptor46, _this);
    _initializerDefineProperty(_this, "rootWordGender", _descriptor47, _this);
    _initializerDefineProperty(_this, "useParenthesesOnGender", _descriptor48, _this);
    _initializerDefineProperty(_this, "frequencyRanking", _descriptor49, _this);
    _initializerDefineProperty(_this, "frequencyWordTypeRanking", _descriptor50, _this);
    _initializerDefineProperty(_this, "frequencyScore", _descriptor51, _this);
    _initializerDefineProperty(_this, "frequencyRanking1", _descriptor52, _this);
    _initializerDefineProperty(_this, "frequencyRanking2", _descriptor53, _this);
    _initializerDefineProperty(_this, "frequencyRanking3", _descriptor54, _this);
    _initializerDefineProperty(_this, "frequencyScoreAdjustment", _descriptor55, _this);
    _initializerDefineProperty(_this, "falsePlurals", _descriptor56, _this);
    _initializerDefineProperty(_this, "pluralOptions", _descriptor57, _this);
    _initializerDefineProperty(_this, "invalidGender", _descriptor58, _this);
    _initializerDefineProperty(_this, "hasAdjectiveForm", _descriptor59, _this);
    _initializerDefineProperty(_this, "note", _descriptor60, _this);
    _initializerDefineProperty(_this, "tag", _descriptor61, _this);
    _initializerDefineProperty(_this, "allowDuplicateRoots", _descriptor62, _this);
    _initializerDefineProperty(_this, "articleHasApostrophe", _descriptor63, _this);
    _initializerDefineProperty(_this, "articleTakesOppositeGender", _descriptor64, _this);
    _initializerDefineProperty(_this, "articleIsHidden", _descriptor65, _this);
    _initializerDefineProperty(_this, "needsSecondaryVideo", _descriptor66, _this);
    _initializerDefineProperty(_this, "conjugatedVerbStringsCount", _descriptor67, _this);
    _initializerDefineProperty(_this, "conjugationPreview", _descriptor68, _this);
    _initializerDefineProperty(_this, "vocabTriadConceptId", _descriptor69, _this);
    _initializerDefineProperty(_this, "vocabTriadDeckId", _descriptor70, _this);
    _initializerDefineProperty(_this, "feminineGenderVariant", _descriptor71, _this);
    _initializerDefineProperty(_this, "masculineGenderVariant", _descriptor72, _this);
    _initializerDefineProperty(_this, "normalizedTargetText", _descriptor73, _this);
    _initializerDefineProperty(_this, "vocabListSentencesCount", _descriptor74, _this);
    _initializerDefineProperty(_this, "hasVocabListSentences", _descriptor75, _this);
    _initializerDefineProperty(_this, "viewsCount", _descriptor76, _this);
    // from user translation
    _initializerDefineProperty(_this, "learned", _descriptor77, _this);
    // from user translation
    _initializerDefineProperty(_this, "reviewing", _descriptor78, _this);
    // from user translation
    _initializerDefineProperty(_this, "userTranslationId", _descriptor79, _this);
    // from user translation
    _initializerDefineProperty(_this, "consecutiveGoodScores", _descriptor80, _this);
    // from user translation
    _initializerDefineProperty(_this, "treePosition", _descriptor81, _this);
    _initializerDefineProperty(_this, "register", _descriptor82, _this);
    _initializerDefineProperty(_this, "hasDictionaryConcept", _descriptor83, _this);
    _initializerDefineProperty(_this, "singularArticle", _descriptor84, _this);
    _initializerDefineProperty(_this, "pluralArticle", _descriptor85, _this);
    _initializerDefineProperty(_this, "definition", _descriptor86, _this);
    _initializerDefineProperty(_this, "synonymsCount", _descriptor87, _this);
    _initializerDefineProperty(_this, "hasRelatedDictionaryWords", _descriptor88, _this);
    _initializerDefineProperty(_this, "hasDictionarySynonyms", _descriptor89, _this);
    _initializerDefineProperty(_this, "wordDerivationStemsCount", _descriptor90, _this);
    _initializerDefineProperty(_this, "wordDerivationChildrenCount", _descriptor91, _this);
    _initializerDefineProperty(_this, "worksheetsCount", _descriptor92, _this);
    _initializerDefineProperty(_this, "stressedCharacters", _descriptor93, _this);
    _initializerDefineProperty(_this, "falseMultipleChoiceOptions", _descriptor94, _this);
    _initializerDefineProperty(_this, "falseMultipleChoiceOptionsEn", _descriptor95, _this);
    _initializerDefineProperty(_this, "falseSynonyms", _descriptor96, _this);
    _initializerDefineProperty(_this, "falseMultipleChoiceOptionsJson", _descriptor97, _this);
    _initializerDefineProperty(_this, "falseMultipleChoiceOptionsLanguageId", _descriptor98, _this);
    _initializerDefineProperty(_this, "sourceLanguageIdsCount", _descriptor99, _this);
    _initializerDefineProperty(_this, "aiLanguagesTranslated", _descriptor100, _this);
    _initializerDefineProperty(_this, "meaningsCount", _descriptor101, _this);
    _initializerDefineProperty(_this, "meaningsReviewed", _descriptor102, _this);
    _initializerDefineProperty(_this, "childWordsList", _descriptor103, _this);
    _initializerDefineProperty(_this, "skipConjugationGeneration", _descriptor104, _this);
    _initializerDefineProperty(_this, "batchCreateInput", _descriptor105, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor106, _this);
    _initializerDefineProperty(_this, "updatedAt", _descriptor107, _this);
    _initializerDefineProperty(_this, "target", _descriptor108, _this);
    _initializerDefineProperty(_this, "level", _descriptor109, _this);
    _initializerDefineProperty(_this, "createdByUser", _descriptor110, _this);
    _initializerDefineProperty(_this, "rootWord", _descriptor111, _this);
    _initializerDefineProperty(_this, "genderVariant", _descriptor112, _this);
    _initializerDefineProperty(_this, "minimalPair", _descriptor113, _this);
    _initializerDefineProperty(_this, "prefix", _descriptor114, _this);
    _initializerDefineProperty(_this, "childWords", _descriptor115, _this);
    _initializerDefineProperty(_this, "pluralNouns", _descriptor116, _this);
    _initializerDefineProperty(_this, "conjugatedVerbStrings", _descriptor117, _this);
    _initializerDefineProperty(_this, "stems", _descriptor118, _this);
    _initializerDefineProperty(_this, "concepts", _descriptor119, _this);
    _initializerDefineProperty(_this, "sources", _descriptor120, _this);
    _initializerDefineProperty(_this, "wordStructures", _descriptor121, _this);
    _initializerDefineProperty(_this, "synonyms", _descriptor122, _this);
    _initializerDefineProperty(_this, "synonymAssociations", _descriptor123, _this);
    _initializerDefineProperty(_this, "wordDerivationStems", _descriptor124, _this);
    _initializerDefineProperty(_this, "wordDerivationChildren", _descriptor125, _this);
    _initializerDefineProperty(_this, "translationSources", _descriptor126, _this);
    _initializerDefineProperty(_this, "meaningSourcePreviews", _descriptor127, _this);
    _initializerDefineProperty(_this, "worksheets", _descriptor128, _this);
    _initializerDefineProperty(_this, "meanings", _descriptor129, _this);
    _initializerDefineProperty(_this, "wordType", _descriptor130, _this);
    _initializerDefineProperty(_this, "rootWordType", _descriptor131, _this);
    return _this;
  }
  _inherits(Word, _RootModel);
  return _createClass(Word, [{
    key: "cardExampleSentence",
    get: function get() {
      var _ref, _this$rootWord;
      return (_ref = (_this$rootWord = this.rootWord) !== null && _this$rootWord !== void 0 && _this$rootWord.id ? this.rootWord.meanings : this.meanings) === null || _ref === void 0 || (_ref = _ref[0]) === null || _ref === void 0 ? void 0 : _ref.highlightedExampleSentence;
    }
  }, {
    key: "cardExampleTranslation",
    get: function get() {
      var _ref2, _this$rootWord2;
      return (_ref2 = (_this$rootWord2 = this.rootWord) !== null && _this$rootWord2 !== void 0 && _this$rootWord2.id ? this.rootWord.meanings : this.meanings) === null || _ref2 === void 0 || (_ref2 = _ref2[0]) === null || _ref2 === void 0 ? void 0 : _ref2.highlightedExampleTranslation;
    }
  }, {
    key: "selfOrRoot",
    get: function get() {
      return this.rootWord || this;
    }
  }, {
    key: "targetTextContainsNumber",
    get: function get() {
      return /\d/.test(this.targetText);
    }
  }, {
    key: "randomPluralOptions",
    get: function get() {
      return this.pluralOptions && this.pluralOptions.split(',').map(function (item) {
        return {
          id: item,
          value: "die ".concat(item),
          correct: false
        };
      });
    }
  }, {
    key: "rightToLeftLanguage",
    get: function get() {
      return _constants.Constants.RTL_LANGUAGE_IDS.includes(this.languageId);
    }
  }, {
    key: "pluralNoun",
    get: function get() {
      return this.pluralNounsSelfOrRoot ? this.pluralNounsSelfOrRoot : {};
    }
  }, {
    key: "pluralNounsString",
    get: function get() {
      return (0, _lodash.uniq)(this.pluralNouns.filter(function (item) {
        return !item.excludeAsPluralForm;
      }).map(function (item) {
        return "".concat(item.definiteArticle || '', " ").concat(item.targetText);
      })).join(', ');
    }
  }, {
    key: "pluralNounsStringWithoutDefiniteArticle",
    get: function get() {
      return (0, _lodash.uniq)(this.pluralNouns.filter(function (item) {
        return !item.excludeAsPluralForm;
      }).map(function (item) {
        return item.targetText;
      })).join(', ');
    }
  }, {
    key: "pluralNounsSelfOrRoot",
    get: function get() {
      return !this.root && (0, _utils.isPresent)(this.rootWord) && this.rootWord.id && this.rootWord.pluralNouns && this.rootWord.pluralNouns.filter(function (item) {
        return !item.excludeAsPluralForm;
      }) ? this.rootWord.pluralNouns.filter(function (item) {
        return !item.excludeAsPluralForm;
      })[0] : this.pluralNouns.filter(function (item) {
        return !item.excludeAsPluralForm;
      })[0];
    }
  }, {
    key: "isInfinitive",
    get: function get() {
      return this.isVerb && this.root;
    }
  }, {
    key: "pluralRoot",
    get: function get() {
      return this.plural && this.root;
    }
  }, {
    key: "isSeparable",
    get: function get() {
      return (0, _utils.isPresent)(this.concepts.find(function (item) {
        return item.abbreviation === 'Sep';
      }));
    }
  }, {
    key: "hasConjugatedVerbStrings",
    get: function get() {
      return (0, _utils.isPresent)(this.conjugatedVerbStrings) && (0, _utils.isPresent)(this.conjugatedVerbStrings[0].singular1p);
    }
  }, {
    key: "targetTextWithDefiniteArticleAndSource",
    get: function get() {
      return (0, _utils.isPresent)(this.sourceText) ? "".concat(this.targetTextWithDefiniteArticle, " - ").concat(this.sourceText) : this.targetTextWithDefiniteArticle;
    }
  }, {
    key: "targetTextWithDefiniteArticleAndSourceAndWordType",
    get: function get() {
      var base = this.targetTextWithDefiniteArticleAndSource;
      var abbrev = this.wordTypeAbbreviation;
      if (!(0, _utils.isPresent)(abbrev)) {
        return base;
      }
      return "".concat(base, " (").concat(abbrev, ")");
    }
  }, {
    key: "genderAbbreviation",
    get: function get() {
      var gender = '';
      if (this.gender === 'feminine') {
        gender = ' (f.)';
      } else if (this.gender === 'masculine' && this.languageId === 'NL') {
        gender = ' (c.)';
      } else if (this.gender === 'masculine') {
        gender = ' (m.)';
      } else if (this.gender === 'neuter') {
        gender = ' (n.)';
      }
      return gender;
    }
  }, {
    key: "targetTextWithGender",
    get: function get() {
      return this.isNoun && this.gender ? "".concat(this.targetText, " ").concat(this.genderAbbreviation) : this.targetText;
    }
  }, {
    key: "targetTextWithDefiniteArticle",
    get: function get() {
      // also in root_word.js, translation_basic.js, word.rb
      if (this.articleIsHidden) {
        return this.targetText;
      }
      if (this.isNoun && this.languageId === 'DE' && this.gender && !this.root && this.caseAbbreviation && !this.plural && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()] && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()][this.gender]) {
        return "".concat(_constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()][this.gender], " ").concat(this.targetText);
      }
      if (this.isNoun && this.languageId === 'DE' && this.gender && !this.root && this.caseAbbreviation && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()] && _constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()].plural) {
        return "".concat(_constants.Constants.ARTICLES[this.caseAbbreviation.toLowerCase()].plural, " ").concat(this.targetText);
      } else if (this.languageId === 'IT' && this.isNoun && this.gender === 'masculine' && "".concat(_constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_FR, "szSZ").includes(this.targetText[0])) {
        if (this.plural) {
          return "gli ".concat(this.targetText);
        } else {
          return "lo ".concat(this.targetText);
        }
      } else if (this.languageId === 'CA' && this.isNoun && !this.plural && this.gender) {
        // Catalan specific logic: feminine words beginning with unstressed I, HI, U or HU should NOT take apostrophe
        if (this.articleHasApostrophe || this.shouldTakeApostropheInCatalan() && !this.feminineWordWithNoApostropheInCatalan()) {
          return "l'".concat(this.targetText).concat(this.genderAbbreviation);
        } else {
          return "".concat(this.definiteArticle, " ").concat(this.targetText).concat(this.articleTakesOppositeGender ? this.genderAbbreviation : '');
        }
      } else if (this.isNoun && !this.plural && this.gender && ['FR', 'IT'].includes(this.languageId) && (this.articleHasApostrophe || _constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_FR.includes(this.targetText[0]))) {
        return "l'".concat(this.targetText).concat(this.languageId !== 'IT' ? this.genderAbbreviation : '');
      } else if (this.isNoun && this.gender && this.definiteArticle) {
        return "".concat(this.definiteArticle, " ").concat(this.targetText).concat(this.articleTakesOppositeGender ? this.genderAbbreviation : '');
      }
      return this.formattedTargetText;
    }
  }, {
    key: "shouldTakeApostropheInCatalan",
    value: function shouldTakeApostropheInCatalan() {
      // Most words beginning with a vowel take an apostrophe in Catalan
      return _constants.Constants.LETTERS_THAT_TAKE_APOSTROPHE_IN_CA.includes(this.targetText[0]);
    }
  }, {
    key: "feminineWordWithNoApostropheInCatalan",
    value: function feminineWordWithNoApostropheInCatalan() {
      // Feminine words beginning with unstressed I, HI, U or HU should NOT take apostrophe
      return this.gender === 'feminine' && /^[iu]|^hi|^hu/i.test(this.targetText);
    }
  }, {
    key: "conjugationTableHasHiddenField",
    get: function get() {
      return (0, _utils.isPresent)(this.conjugatedVerbStrings.find(function (item) {
        return item.hideSingular1p || item.hideSingular2 || item.hideSingular3p || item.hidePlural1p || item.hidePlural2p || item.hidePlural3p;
      }));
    }
  }, {
    key: "targetTextWithDefiniteArticleNoParenthesis",
    get: function get() {
      return this.targetTextWithDefiniteArticle.split('(')[0];
    }
  }, {
    key: "targetTextWithNominativeDefiniteArticle",
    get: function get() {
      return (0, _utils.isPresent)(this.gender) && this.definiteArticle && this.isNoun ? "".concat(this.definiteArticle, " ").concat(this.targetText) : this.targetText;
    }
  }, {
    key: "targetTextWithPrefix",
    get: function get() {
      return (0, _utils.isPresent)(this.prefix) ? "".concat(this.formattedTargetText, "...").concat(this.prefix.targetText) : this.targetTextWithDefiniteArticle;
    }
  }, {
    key: "genderAbbreviationWithoutPlural",
    get: function get() {
      if ((0, _utils.isPresent)(this.gender)) {
        return this.gender[0];
      }
      return null;
    }
  }, {
    key: "definiteArticle",
    get: function get() {
      if ((0, _utils.isPresent)(this.gender)) {
        var article = this.plural ? this.pluralArticle : this.singularArticle;
        if (this.useParenthesesOnGender) {
          article = "(".concat(article, ")");
        }
        return article;
      }
      return null;
    }
  }, {
    key: "conjugatedVerbStringsSummary",
    get: function get() {
      var _this$rootWord3;
      var conjugatedVerbStrings = (0, _utils.isPresent)(this.conjugatedVerbStrings) ? this.conjugatedVerbStrings : (_this$rootWord3 = this.rootWord) === null || _this$rootWord3 === void 0 ? void 0 : _this$rootWord3.conjugatedVerbStrings;
      if ((0, _utils.isPresent)(conjugatedVerbStrings)) {
        var verbStringsArray = (0, _lodash.keys)(_constants.Constants.GRAMMAR_TENSES[this.languageId]).map(function (conceptId) {
          var conjugatedVerbString = conjugatedVerbStrings.find(function (item) {
            return item.concept && item.concept.id === conceptId;
          });
          if (conjugatedVerbString && !conjugatedVerbString.hideSingular3p) {
            return conjugatedVerbString.singular3p;
          }
        }).filter(function (item) {
          return (0, _utils.isPresent)(item);
        });
        if (this.languageId === 'ES') {
          return verbStringsArray.slice(0, 3).join(' · ');
        } else if (this.languageId === 'FR') {
          return verbStringsArray.slice(0, 2).join(' · ');
        } else {
          return verbStringsArray.join(' · ');
        }
      }
      return this.conjugationPreview || null;
    }
  }, {
    key: "isNominative",
    get: function get() {
      return (0, _utils.isPresent)(this.concepts.find(function (item) {
        return item.grammarCase === 'Nm';
      }));
    }
  }, {
    key: "isDative",
    get: function get() {
      return (0, _utils.isPresent)(this.concepts.find(function (item) {
        return item.grammarCase === 'Dt' || item.grammarCase === '2w-Dt';
      }));
    }
  }, {
    key: "isVerb",
    get: function get() {
      return this.wordTypeId === '4c4389c1-f805-4d1c-ba45-6721cf400aef';
    }
  }, {
    key: "isNoun",
    get: function get() {
      return this.wordTypeId === 'd5c5fcef-bb92-48a8-b00b-e7c71cb33068';
    }
  }, {
    key: "isPronoun",
    get: function get() {
      return this.wordTypeId === '19fbf309-98b1-42e4-a226-151eedb37641';
    }
  }, {
    key: "isNumber",
    get: function get() {
      return this.wordTypeId === '1a0d84ff-a903-4be9-b0a8-22fdcc211506';
    }
  }, {
    key: "isGrapheme",
    get: function get() {
      return this.wordTypeId === '52808410-545c-40c9-aeb9-8285f04070dc';
    }
  }, {
    key: "isPhoneme",
    get: function get() {
      return this.wordTypeId === '4903f2ec-3b84-4dbe-8659-93cf985e86fc';
    }
  }, {
    key: "isAdjective",
    get: function get() {
      return this.hasWordType && this.wordType.name.match('Adjective');
    }
  }, {
    key: "isAdverb",
    get: function get() {
      return this.hasWordType && this.wordType.name.match('Adverb');
    }
  }, {
    key: "isGenitive",
    get: function get() {
      return (0, _utils.isPresent)(this.concepts.find(function (item) {
        return item.grammarCase === 'Gn';
      }));
    }
  }, {
    key: "isAccusative",
    get: function get() {
      return (0, _utils.isPresent)(this.concepts.find(function (item) {
        return item.grammarCase === 'Ak' || item.grammarCase === '2w-Ak';
      }));
    }
  }, {
    key: "hasVideoClip",
    get: function get() {
      return (0, _utils.isPresent)(this.videoClip);
    }
  }, {
    key: "videoClip",
    get: function get() {
      return this.target && this.target.videoClip;
    }
  }, {
    key: "dictionaryUrl",
    get: function get() {
      if (this.languageId === 'DE') {
        return (0, _utils.isPresent)(this.targetText) ? "http://dict.cc?s=".concat(this.targetText.replace(' ', '+')) : null;
      } else if (this.languageId === 'FR') {
        return (0, _utils.isPresent)(this.targetText) ? "http://enfr.dict.cc?s=".concat(this.targetText.replace(' ', '+')) : null;
      } else if (this.languageId === 'ES') {
        return (0, _utils.isPresent)(this.targetText) ? "https://www.linguee.es/espanol-ingles/search?source=auto&query=".concat(this.targetText.replace(' ', '+')) : null;
      }
    }
  }, {
    key: "wordTypeName",
    get: function get() {
      return this.hasWordType ? this.wordType.name : null;
    }
  }, {
    key: "conceptIds",
    get: function get() {
      return this.concepts.map(function (item) {
        return item.id;
      });
    }
  }, {
    key: "wordTypeConcept",
    get: function get() {
      var irregularConcept = this.concepts.find(function (item) {
        return item.showAsWordType && item.joinType === 'verb';
      });
      return irregularConcept || this.concepts.find(function (item) {
        return item.showAsWordType;
      });
    }
  }, {
    key: "hasWordTypeConcept",
    get: function get() {
      return (0, _utils.isPresent)(this.wordTypeConcept);
    }
  }, {
    key: "hasAssignableRoot",
    get: function get() {
      return true;
    }
  }, {
    key: "hasPrefix",
    get: function get() {
      return (0, _utils.isPresent)(this.prefix) && (0, _utils.isPresent)(this.prefix.id);
    }
  }, {
    key: "hasSource",
    get: function get() {
      return (0, _utils.isPresent)((0, _mobx.toJS)(this.translationSources.filter(function (item) {
        return ['EN', 'U'].includes(item.source.languageId) && (0, _utils.isBlank)(item.meaningId);
      })));
    }
  }, {
    key: "hasTranslationSources",
    get: function get() {
      return (0, _utils.isPresent)(this.translationSources) && (0, _utils.isPresent)(this.translationSourceList);
    }
  }, {
    key: "hasWordType",
    get: function get() {
      return (0, _utils.isPresent)(this.wordType) && (0, _utils.isPresent)(this.wordType.id);
    }
  }, {
    key: "wordTypeAbbreviation",
    get: function get() {
      var _this$wordType;
      return (0, _utils.isPresent)((_this$wordType = this.wordType) === null || _this$wordType === void 0 ? void 0 : _this$wordType.abbreviation) ? this.wordType.abbreviation : null;
    }
  }, {
    key: "sourceList",
    get: function get() {
      if ((0, _utils.isPresent)((0, _mobx.toJS)(this.translationSources))) {
        return this.translationSourceList;
      }
      return (0, _lodash.compact)(this.sources.map(function (item) {
        return item.text;
      })).join(', ');
    }
  }, {
    key: "sourceText",
    get: function get() {
      return this.vocabSourceList;
    }
  }, {
    key: "vocabSourceList",
    get: function get() {
      if ((0, _lodash.isEmpty)(this.translationSources)) {
        return;
      }
      return this.vocabSources.join(', ');
    }
  }, {
    key: "publicSynonyms",
    get: function get() {
      var _orderBy$map;
      if ((0, _utils.isBlank)(this.synonymAssociations)) {
        return;
      }
      var synonyms = (_orderBy$map = (0, _lodash.orderBy)(this.synonymAssociations, ['similarity', 'levelAbbreviation'], ['desc', 'asc']).map(function (item) {
        return item.synonym;
      })) === null || _orderBy$map === void 0 ? void 0 : _orderBy$map.filter(function (synonym) {
        return (0, _utils.isPresent)(synonym) && synonym.publicInVocab;
      });
      return (0, _lodash.uniqBy)(synonyms, 'id');
    }
  }, {
    key: "acceptedEnglishTranslationSources",
    get: function get() {
      if ((0, _lodash.isEmpty)(this.translationSources)) {
        return [];
      }
      return this.translationSources.filter(function (item) {
        var _item$source;
        return item.source && (0, _utils.isBlank)(item.meaningId) && ((_item$source = item.source) === null || _item$source === void 0 ? void 0 : _item$source.languageId) == 'EN' && !item.rejected && (!item.userId || item.accepted);
      });
    }
  }, {
    key: "vocabSources",
    get: function get() {
      var _this2 = this;
      return (0, _lodash.compact)(this.acceptedEnglishTranslationSources.map(function (item) {
        return _this2.sourceTextWithGenderAbbreviation(item.source);
      }));
    }
  }, {
    key: "vocabSourcesWithoutGenderAbbreviation",
    get: function get() {
      return (0, _lodash.compact)(this.acceptedEnglishTranslationSources.map(function (item) {
        return item.source ? item.source.text : null;
      }));
    }
  }, {
    key: "translationSourceList",
    get: function get() {
      return (0, _lodash.compact)(this.acceptedEnglishTranslationSources.map(function (item) {
        return item.source ? item.source.text : null;
      })).join(', ');
    }
  }, {
    key: "targetWithWordTypeAndSource",
    get: function get() {
      return this.formatTarget({
        wordType: true,
        source: true
      });
    }
  }, {
    key: "targetWithWordTypeParentAndSource",
    get: function get() {
      return this.formatTarget({
        wordType: true,
        parent: true,
        source: true,
        label: true
      });
    }
  }, {
    key: "targetWithWordTypeParentInfinitiveAndSource",
    get: function get() {
      return this.formatTarget({
        wordType: true,
        root: true,
        plural: true,
        infinitive: true,
        parent: true,
        source: true,
        "case": true,
        label: true
      });
    }
  }, {
    key: "targetWithWordTypeParentInfinitiveAndSourceAndLevel",
    get: function get() {
      return this.formatTarget({
        wordType: true,
        root: true,
        plural: true,
        infinitive: true,
        parent: true,
        source: true,
        "case": true,
        label: true,
        level: true
      });
    }
  }, {
    key: "targetWithWordTypeParentInfinitiveAndSourceAndLevelAndGender",
    get: function get() {
      return this.formatTarget({
        wordType: true,
        root: true,
        plural: true,
        infinitive: true,
        parent: true,
        source: true,
        "case": true,
        label: true,
        level: true,
        gender: true
      });
    }
  }, {
    key: "targetWithGenderAndSentencesCount",
    get: function get() {
      return this.formatTarget({
        gender: true,
        sentencesCount: true
      });
    }
  }, {
    key: "targetWithPronoun",
    get: function get() {
      if (this.wordTypeName === 'Noun' && this.gender) {
        var genders = {
          masculine: 'der',
          feminine: 'die',
          neuter: 'das'
        };
        return "".concat(genders[this.gender], " ").concat(this.targetText);
      }
      return this.targetText;
    }
  }, {
    key: "invalid",
    get: function get() {
      return this.invalidSource || this.invalidWithoutSource;
    }
  }, {
    key: "invalidWithoutSource",
    get: function get() {
      return this.invalidWordType || this.invalidRoot || this.invalidLevel || this.invalidGender || this.invalidInfinitive || this.invalidTense || this.invalidCase || this.invalidPrefix;
    }
  }, {
    key: "invalidSource",
    get: function get() {
      var _this$languageId;
      return !((_this$languageId = this.languageId) !== null && _this$languageId !== void 0 && _this$languageId.startsWith('EN')) && this.sourcesCount === 0 && !this.blankSource;
    }
  }, {
    key: "invalidWordType",
    get: function get() {
      return !this.hasWordType;
    }
  }, {
    key: "invalidRoot",
    get: function get() {
      return !this.root && this.hasAssignableRoot && (0, _utils.isBlank)(this.rootWord) && !this.isVerb;
    }
  }, {
    key: "invalidLevel",
    get: function get() {
      return (0, _utils.isBlank)((0, _mobx.toJS)(this.level)) || !this.level.id;
    }
  }, {
    key: "invalidPrefix",
    get: function get() {
      return !this.root && this.isStem && !this.hasPrefix;
    }
  }, {
    key: "invalidInfinitive",
    get: function get() {
      return this.isVerb && !this.isInfinitive && !this.hasInfinitiveVerb;
    }
  }, {
    key: "invalidTense",
    get: function get() {
      return !this.wordScope && this.isVerb && !this.hasGrammarTense && !this.root && this.hasSentences;
    }
  }, {
    key: "invalidCase",
    get: function get() {
      return this.languageId === 'DE' && !this.root && this.hasWordType && this.wordType.requiresCase && !this.hasGrammarCase && this.hasSentences;
    }
  }, {
    key: "hasGrammarTense",
    get: function get() {
      return (0, _utils.isPresent)(this.concepts.find(function (item) {
        return item.grammarTense;
      }));
    }
  }, {
    key: "grammarTense",
    get: function get() {
      return this.concepts.find(function (item) {
        return item.grammarTense;
      });
    }
  }, {
    key: "hasGrammarCase",
    get: function get() {
      return (0, _utils.isPresent)(this.grammarCase);
    }
  }, {
    key: "grammarCase",
    get: function get() {
      return this.concepts.find(function (item) {
        return item.grammarCase;
      });
    }
  }, {
    key: "caseAbbreviation",
    get: function get() {
      var concept = this.concepts.find(function (item) {
        return (0, _utils.isPresent)(item.grammarCase);
      });
      if ((0, _utils.isPresent)(concept)) {
        return concept.grammarCase;
      }
    }
  }, {
    key: "caseName",
    get: function get() {
      if ((0, _utils.isPresent)(this.caseAbbreviation)) {
        return {
          ak: 'Accusative',
          nm: 'Nominative',
          dt: 'Dative',
          gn: 'Genitive'
        }[this.caseAbbreviation.toLowerCase()];
      }
    }
  }, {
    key: "tenseAbbreviation",
    get: function get() {
      var concept = this.concepts.find(function (item) {
        return (0, _utils.isPresent)(item.tenseCase);
      });
      if ((0, _utils.isPresent)(concept)) {
        return concept.tenseCase;
      }
    }
  }, {
    key: "hasInfinitiveVerb",
    get: function get() {
      return !this.isInfinitive && (0, _utils.isPresent)(this.rootWord) && (0, _utils.isPresent)(this.rootWord.id) && this.rootWord.wordTypeId === '4c4389c1-f805-4d1c-ba45-6721cf400aef';
    }
  }, {
    key: "infinitiveVerb",
    get: function get() {
      return this.hasInfinitiveVerb ? this.rootWord : null;
    }
  }, {
    key: "hasConcept",
    value: function hasConcept(id) {
      return this.concepts.find(function (item) {
        return item.id === id;
      });
    }
  }, {
    key: "hasRelatedWords",
    get: function get() {
      var _this$wordType2;
      return ((_this$wordType2 = this.wordType) === null || _this$wordType2 === void 0 ? void 0 : _this$wordType2.name) !== 'Number' && (this.synonymsCount > 0 || this.wordDerivationStemsCount > 0 || this.wordDerivationChildrenCount > 0);
    }
  }, {
    key: "relatedWords",
    get: function get() {
      var _this$wordType3;
      return ((_this$wordType3 = this.wordType) === null || _this$wordType3 === void 0 ? void 0 : _this$wordType3.name) === 'Number' ? [] : (0, _lodash.orderBy)([].concat(_toConsumableArray(this.wordDerivationStems), _toConsumableArray(this.wordDerivationChildren)), ['frequencyRanking'], ['asc']);
    }
  }, {
    key: "relatedPhrases",
    get: function get() {
      return [].concat(_toConsumableArray(this.wordDerivationStems.filter(function (item) {
        var _item$wordType;
        return ((_item$wordType = item.wordType) === null || _item$wordType === void 0 ? void 0 : _item$wordType.abbreviation) === 'phr';
      })), _toConsumableArray(this.wordDerivationChildren.filter(function (item) {
        var _item$wordType2;
        return ((_item$wordType2 = item.wordType) === null || _item$wordType2 === void 0 ? void 0 : _item$wordType2.abbreviation) === 'phr';
      })));
    }
  }, {
    key: "publicPhrase",
    get: function get() {
      var _this$wordType4, _this$target;
      return ((_this$wordType4 = this.wordType) === null || _this$wordType4 === void 0 ? void 0 : _this$wordType4.abbreviation) === 'phr' && !this.excludeFromPublicLists && !this.pendingApproval && (0, _utils.isPresent)((_this$target = this.target) === null || _this$target === void 0 ? void 0 : _this$target.videoClip) && this.enSourcesCount > 0;
    }
  }, {
    key: "formatTarget",
    value: function formatTarget(params) {
      var ary = [];
      var targetText;
      if (params.pronoun) {
        targetText = this.targetWithPronoun;
      } else {
        targetText = this.targetText;
      }
      if (params.gender && (0, _utils.isPresent)(this.gender)) {
        targetText = "".concat(targetText).concat(this.genderAbbreviation);
      }
      if (params.wordType && (0, _utils.isPresent)(this.wordType) && this.wordType.abbreviation) {
        ary.push(this.wordType.abbreviation);
      }
      if (params.infinitive && this.isInfinitive) {
        ary.push('inf');
      }
      if (params.plural && this.plural) {
        ary.push('pl');
      }
      if (params.parent && (0, _utils.isPresent)(this.infinitiveVerb) && this.infinitiveVerb.targetText) {
        ary.push(this.infinitiveVerb.targetText);
      }
      if (params.parent && !(0, _utils.isPresent)(this.infinitiveVerb) && (0, _utils.isPresent)(this.rootWord)) {
        ary.push("[".concat(this.rootWord.targetText, "]"));
      }
      if (params.label && (0, _utils.isPresent)(this.label)) {
        ary.push(this.label);
      }
      if (params.root && this.root) {
        ary.push('root');
      }
      if (params["case"] && this.caseAbbreviation) {
        ary.push(this.caseAbbreviation);
      }
      if (ary.length > 0) {
        targetText = "".concat(targetText, " (").concat(ary.join(', '), ")");
      }
      if (params.source && (0, _utils.isPresent)(this.sourceList)) {
        targetText = "".concat(targetText, " - ").concat(this.sourceList);
      }
      if (params.level && (0, _utils.isPresent)(this.level)) {
        targetText = "".concat(targetText, " - ").concat(this.level.abbreviation);
      }
      if (params.sentencesCount && (0, _utils.isPresent)(this.sentencesCount)) {
        targetText = "".concat(targetText, " - ").concat(this.sentencesCount, " sentences");
      }
      return targetText;
    }
  }, {
    key: "setOriginalDeckId",
    value: function setOriginalDeckId(originalDeckId) {
      this.originalDeckId = originalDeckId;
    }
  }, {
    key: "setSelectedDeckId",
    value: function setSelectedDeckId(selectedDeckId) {
      this.selectedDeckId = selectedDeckId;
    }
  }, {
    key: "setViewsCount",
    value: function setViewsCount(viewsCount) {
      this.viewsCount = viewsCount;
    }
  }, {
    key: "clearDeckIds",
    value: function clearDeckIds() {
      this.originalDeckId = null;
      this.selectedDeckId = null;
    }
  }, {
    key: "setSentences",
    value: function setSentences(sentences) {
      this.sentences = sentences;
    }
  }, {
    key: "isEnglishLanguageId",
    value: function isEnglishLanguageId(languageId) {
      return Boolean(languageId && languageId.startsWith('EN'));
    }
  }, {
    key: "isNativeLanguageForUser",
    value: function isNativeLanguageForUser(languageId, user) {
      if (!languageId || !(user !== null && user !== void 0 && user.languageId) || this.isEnglishLanguageId(languageId)) {
        return false;
      }
      return languageId === user.languageId;
    }
  }, {
    key: "userPrefersBritishEnglish",
    value: function userPrefersBritishEnglish(user) {
      var userLangId = user === null || user === void 0 ? void 0 : user.languageId;
      return userLangId === 'EN2' || userLangId === 'EN' && (user === null || user === void 0 ? void 0 : user.useBritishEnglish);
    }
  }, {
    key: "preferredEnglishLanguageIds",
    value: function preferredEnglishLanguageIds(user) {
      return this.userPrefersBritishEnglish(user) ? ['EN2', 'EN'] : ['EN', 'EN2'];
    }
  }, {
    key: "orderEnglishSourcesForUser",
    value: function orderEnglishSourcesForUser(englishSources, user) {
      if (!(0, _utils.isPresent)(englishSources)) {
        return [];
      }
      var byScore = function byScore(sourceA, sourceB) {
        return (sourceB.aggregateScore || 0) - (sourceA.aggregateScore || 0);
      };
      var sourcesByLanguage = {};
      englishSources.forEach(function (translationSource) {
        if (!(translationSource !== null && translationSource !== void 0 && translationSource.source)) {
          return;
        }
        var languageId = translationSource.source.languageId;
        if (!sourcesByLanguage[languageId]) {
          sourcesByLanguage[languageId] = [];
        }
        sourcesByLanguage[languageId].push(translationSource);
      });
      Object.values(sourcesByLanguage).forEach(function (sources) {
        sources.sort(byScore);
      });
      return this.preferredEnglishLanguageIds(user).flatMap(function (languageId) {
        return sourcesByLanguage[languageId] || [];
      });
    }
  }, {
    key: "partitionTranslationSourcesByLanguage",
    value: function partitionTranslationSourcesByLanguage(translationSources, user) {
      var _this3 = this;
      var englishSources = [];
      var nativeSources = [];
      (translationSources || []).forEach(function (translationSource) {
        if (!(translationSource !== null && translationSource !== void 0 && translationSource.source)) {
          return;
        }
        if (_this3.isEnglishLanguageId(translationSource.source.languageId)) {
          englishSources.push(translationSource);
        } else if (_this3.isNativeLanguageForUser(translationSource.source.languageId, user)) {
          nativeSources.push(translationSource);
        }
      });
      return {
        englishSources: englishSources,
        nativeSources: nativeSources
      };
    }
  }, {
    key: "selectedMeaningSourcesForUser",
    value: function selectedMeaningSourcesForUser(translationSources, user) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        singleMeaning: false
      };
      if (!(0, _utils.isPresent)(translationSources)) {
        return [];
      }
      var filteredSources = translationSources.filter(function (translationSource) {
        return Boolean(translationSource === null || translationSource === void 0 ? void 0 : translationSource.source);
      });
      if (!(0, _utils.isPresent)(filteredSources)) {
        return [];
      }
      var _this$partitionTransl = this.partitionTranslationSourcesByLanguage(filteredSources, user),
        englishSources = _this$partitionTransl.englishSources,
        nativeSources = _this$partitionTransl.nativeSources;
      var orderedEnglishSources = this.orderEnglishSourcesForUser(englishSources, user);
      var primarySourcesCap = params.singleMeaning ? 2 : 1;
      if (this.isEnglishLanguageId(user === null || user === void 0 ? void 0 : user.languageId)) {
        if ((0, _utils.isPresent)(orderedEnglishSources)) {
          return orderedEnglishSources.slice(0, primarySourcesCap);
        }
        return filteredSources.slice(0, primarySourcesCap);
      }
      if (user !== null && user !== void 0 && user.onlyShowNativeLanguage) {
        if ((0, _utils.isPresent)(nativeSources)) {
          return nativeSources.slice(0, primarySourcesCap);
        }
        if ((0, _utils.isPresent)(orderedEnglishSources)) {
          return orderedEnglishSources.slice(0, 1);
        }
        return filteredSources.slice(0, 1);
      }
      var selectedNativeSources = nativeSources.slice(0, primarySourcesCap);
      if (!(0, _utils.isPresent)(selectedNativeSources)) {
        if ((0, _utils.isPresent)(orderedEnglishSources)) {
          return orderedEnglishSources.slice(0, 1);
        }
        return filteredSources.slice(0, 1);
      }
      var englishSource = orderedEnglishSources.slice(0, 1);
      if ((user === null || user === void 0 ? void 0 : user.showNativeLanguageFirst) === false) {
        return englishSource.concat(selectedNativeSources);
      }
      return selectedNativeSources.concat(englishSource);
    }
  }, {
    key: "orderedVocabMeaningSourcesByLanguage",
    value: function orderedVocabMeaningSourcesByLanguage(user, sources) {
      if (!(0, _utils.isPresent)(sources)) {
        return [];
      }
      var _this$partitionTransl2 = this.partitionTranslationSourcesByLanguage(sources, user),
        englishSources = _this$partitionTransl2.englishSources,
        nativeSources = _this$partitionTransl2.nativeSources;
      var orderedEnglishSources = this.orderEnglishSourcesForUser(englishSources, user);
      if (this.isEnglishLanguageId(user === null || user === void 0 ? void 0 : user.languageId)) {
        return orderedEnglishSources.concat(nativeSources);
      }
      if (user !== null && user !== void 0 && user.onlyShowNativeLanguage) {
        if ((0, _utils.isPresent)(nativeSources)) {
          return nativeSources;
        }
        return orderedEnglishSources;
      }
      if ((user === null || user === void 0 ? void 0 : user.showNativeLanguageFirst) === false) {
        return orderedEnglishSources.concat(nativeSources);
      }
      return nativeSources.concat(orderedEnglishSources);
    }
  }, {
    key: "vocabMeaningSourcesForUser",
    value: function vocabMeaningSourcesForUser(user) {
      var _this4 = this;
      var shouldShowMeaningSources = (user === null || user === void 0 ? void 0 : user.showMeanings) && (user === null || user === void 0 ? void 0 : user.showVocabMeanings) !== false;
      if (!shouldShowMeaningSources) {
        return [];
      }
      var meanings = this.meanings || [];
      var meaningSources = [];
      meanings.forEach(function (meaning) {
        var translationSources = meaning.translationSourcesForUser ? meaning.translationSourcesForUser(user) : [];
        _this4.selectedMeaningSourcesForUser(translationSources, user, {
          singleMeaning: meanings.length === 1
        }).forEach(function (translationSource) {
          if (translationSource !== null && translationSource !== void 0 && translationSource.source) {
            meaningSources.push(translationSource);
          }
        });
      });
      if ((0, _utils.isPresent)(meaningSources)) {
        return this.orderedVocabMeaningSourcesByLanguage(user, meaningSources);
      }
      var previewSourcesByMeaningId = new Map();
      (this.meaningSourcePreviews || []).forEach(function (translationSource, index) {
        if (!(translationSource !== null && translationSource !== void 0 && translationSource.source)) {
          return;
        }
        var meaningId = translationSource.meaningId || "preview-".concat(index);
        if (!previewSourcesByMeaningId.has(meaningId)) {
          previewSourcesByMeaningId.set(meaningId, []);
        }
        previewSourcesByMeaningId.get(meaningId).push(translationSource);
      });
      var previewSources = [];
      var singlePreviewMeaning = previewSourcesByMeaningId.size === 1;
      previewSourcesByMeaningId.forEach(function (translationSources) {
        _this4.selectedMeaningSourcesForUser(translationSources, user, {
          singleMeaning: singlePreviewMeaning
        }).forEach(function (translationSource) {
          if (translationSource !== null && translationSource !== void 0 && translationSource.source) {
            previewSources.push(translationSource);
          }
        });
      });
      return this.orderedVocabMeaningSourcesByLanguage(user, previewSources);
    }
  }, {
    key: "visibleVocabSourcesForUser",
    value: function visibleVocabSourcesForUser(user) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var shouldShowMeaningSources = (user === null || user === void 0 ? void 0 : user.showMeanings) && (user === null || user === void 0 ? void 0 : user.showVocabMeanings) !== false;
      if (shouldShowMeaningSources) {
        if ((0, _utils.isPresent)(this.meanings) || (0, _utils.isPresent)(this.meaningSourcePreviews)) {
          return this.vocabMeaningSourcesForUser(user);
        }
      }
      return this.vocabSourceForUser(user, params) || [];
    }
  }, {
    key: "vocabSourceForUser",
    value: function vocabSourceForUser(user) {
      var _this5 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      params.allowHideEnglish = (0, _utils.isPresent)(params.allowHideEnglish) ? params.allowHideEnglish : true;
      if ((0, _lodash.isEmpty)(this.translationSources)) {
        return;
      }
      var sources = this.translationSources.filter(function (item) {
        var _item$source2, _item$source3, _item$source4, _item$source5;
        return ((_item$source2 = item.source) === null || _item$source2 === void 0 ? void 0 : _item$source2.languageId) !== 'U' && !item.rejected && (0, _utils.isBlank)(item.meaningId) && (item.accepted || !item.userId) && (((_item$source3 = item.source) === null || _item$source3 === void 0 ? void 0 : _item$source3.languageId) === 'EN' || ((_item$source4 = item.source) === null || _item$source4 === void 0 ? void 0 : _item$source4.languageId) === 'EN2' && _this5.userPrefersBritishEnglish(user) || _this5.isNativeLanguageForUser((_item$source5 = item.source) === null || _item$source5 === void 0 ? void 0 : _item$source5.languageId, user));
      });
      if ((user.hideEnglishTranslations || params.forceHideEnglishTranslations) && (0, _utils.isPresent)(sources.filter(function (item) {
        var _item$source6;
        return !((_item$source6 = item.source) !== null && _item$source6 !== void 0 && _item$source6.languageId.startsWith('EN'));
      })) && params.allowHideEnglish) {
        sources = sources.filter(function (item) {
          var _item$source7;
          return !((_item$source7 = item.source) !== null && _item$source7 !== void 0 && _item$source7.languageId.startsWith('EN'));
        });
      }
      sources = sources.filter(function (item) {
        return (0, _utils.isBlank)(item.score) || item.score > -1;
      });
      sources = sources.filter(function (item) {
        return item.source;
      });
      var _this$partitionTransl3 = this.partitionTranslationSourcesByLanguage(sources, user),
        englishSources = _this$partitionTransl3.englishSources,
        nativeSources = _this$partitionTransl3.nativeSources;
      var orderedEnglishSources = this.orderEnglishSourcesForUser(englishSources, user);
      var sortedNativeSources = nativeSources.sort(function (sourceA, sourceB) {
        return (sourceB.aggregateScore || 0) - (sourceA.aggregateScore || 0);
      });
      var englishFirst = !user.onlyShowNativeLanguage && !user.showNativeLanguageFirst;
      if (englishFirst) {
        return orderedEnglishSources.concat(sortedNativeSources);
      }
      return sortedNativeSources.concat(orderedEnglishSources);
    }
  }, {
    key: "compareTranslationSources",
    value: function compareTranslationSources(translationSourceA, translationSourceB, englishFirst) {
      var aIsEn = translationSourceA.source.languageId.startsWith('EN');
      var bIsEn = translationSourceB.source.languageId.startsWith('EN');
      if (aIsEn === bIsEn) {
        return (translationSourceB.aggregateScore || 0) - (translationSourceA.aggregateScore || 0);
      }
      return (aIsEn ? -1 : 1) * (englishFirst ? 1 : -1);
    }
  }, {
    key: "vocabSourceListForUser",
    value: function vocabSourceListForUser(user) {
      var _this6 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var sourceList = this.visibleVocabSourcesForUser(user, params);
      if (params.monolingual) {
        sourceList = sourceList.filter(function (item) {
          var _item$source8;
          return ((_item$source8 = item.source) === null || _item$source8 === void 0 ? void 0 : _item$source8.languageId) === user.languageId;
        });
      }
      if ((0, _utils.isPresent)(sourceList)) {
        return sourceList.map(function (item) {
          return item.source && _this6.sourceTextWithGenderAbbreviation(item.source, user);
        });
      }
      return null;
    }
  }, {
    key: "vocabEnSourceListForUser",
    value: function vocabEnSourceListForUser(user) {
      var sourceList = this.vocabSourceForUser(user, {
        allowHideEnglish: false
      });
      if ((0, _utils.isPresent)(sourceList)) {
        return sourceList.filter(function (item) {
          var _item$source9;
          return ['EN', 'EN2'].includes((_item$source9 = item.source) === null || _item$source9 === void 0 ? void 0 : _item$source9.languageId);
        }).map(function (item) {
          return item === null || item === void 0 ? void 0 : item.source.textForUser(user);
        });
      }
      return null;
    }
  }, {
    key: "firstVocabSourceForUser",
    value: function firstVocabSourceForUser(user) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        allowHideEnglish: true
      };
      var sourceList = this.vocabSourceForUser(user, params);
      if ((0, _utils.isPresent)(sourceList)) {
        return this.sourceTextWithGenderAbbreviation(sourceList[0].source, user);
      }
      return null;
    }
  }, {
    key: "sourceTextWithGenderAbbreviation",
    value: function sourceTextWithGenderAbbreviation(source) {
      var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (user) {
        return source ? "".concat(source.textForUser(user)).concat(source.displayGender ? this.genderAbbreviation : '') : null;
      }
      return source ? "".concat(source.text).concat(source.displayGender ? this.genderAbbreviation : '') : null;
    }
  }, {
    key: "sourceTextForUser",
    value: function sourceTextForUser(user) {
      var sourceListForUser = this.vocabSourceListForUser(user, {
        forceHideEnglishTranslations: true
      });
      if ((0, _utils.isPresent)(sourceListForUser)) {
        return sourceListForUser.join(', ');
      }
      return this.vocabSourceList || '';
    }
  }, {
    key: "sourceTextForUserLanguageId",
    value: function sourceTextForUserLanguageId(user) {
      if ((0, _utils.isPresent)(this.vocabSourceForUser(user).filter(function (item) {
        var _item$source0;
        return ((_item$source0 = item.source) === null || _item$source0 === void 0 ? void 0 : _item$source0.languageId) === user.languageId;
      }))) {
        return user.languageId;
      }
      return 'EN';
    }
  }, {
    key: "digitSourceText",
    get: function get() {
      var _this$translationSour;
      return this.isNumber && ((_this$translationSour = this.translationSources.find(function (item) {
        var _item$source1;
        return ((_item$source1 = item.source) === null || _item$source1 === void 0 ? void 0 : _item$source1.languageId) === 'U';
      })) === null || _this$translationSour === void 0 ? void 0 : _this$translationSour.source.text);
    }
  }, {
    key: "formattedTargetText",
    get: function get() {
      if (!this.isNumber || this.isDate || isNaN(Number(this.targetText))) {
        return this.targetText;
      }
      return Number(this.targetText).toLocaleString(this.languageId);
    }
  }, {
    key: "formattedDigitSourceText",
    get: function get() {
      return isNaN(Number(this.digitSourceText)) || this.isDate ? this.digitSourceText : parseInt(this.digitSourceText).toLocaleString('en');
    }
  }, {
    key: "publicInVocab",
    get: function get() {
      var _this$wordType5, _this$target2;
      // should follow the logic of join_user_translations_service.rb also in translation_basic.js
      return ((_this$wordType5 = this.wordType) === null || _this$wordType5 === void 0 ? void 0 : _this$wordType5.showInVocabTrainer) && !this.excludeFromPublicLists && !this.pendingApproval && (0, _utils.isPresent)((_this$target2 = this.target) === null || _this$target2 === void 0 ? void 0 : _this$target2.videoClip) && this.enSourcesCount > 0;
    }
  }, {
    key: "messagePublicInVocab",
    get: function get() {
      var _this$wordType6, _this$target3;
      // should follow the logic of join_user_translations_service.rb
      if (this.publicInVocab) {
        return;
      }
      var message = ['This word doesn\'t appear in the dictionary because'];
      if (!((_this$wordType6 = this.wordType) !== null && _this$wordType6 !== void 0 && _this$wordType6.showInVocabTrainer)) {
        message.push('  - this word type never appears in the dictionary');
      }
      if (this.excludeFromPublicLists) {
        message.push('  - it is excluded from the dictionary');
      }
      if (this.pendingApproval) {
        message.push('  - it hasn\'t been approved yet');
      }
      if (!(0, _utils.isPresent)((_this$target3 = this.target) === null || _this$target3 === void 0 ? void 0 : _this$target3.videoClip)) {
        message.push('  - it has no video clip');
      }
      if (this.enSourcesCount === 0) {
        message.push('  - it has no English source');
      }
      if (/\d/.test(this.targetText)) {
        message.push('  - it contains a digit');
      }
      return message;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "sentences", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "originalDeckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedDeckId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "id", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "wordScope", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "alternateGenders", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hideFromGenderTrainer", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hideFromPluralTrainer", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "hideFromSynonymTrainer", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "hideFromConjugationTrainer", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "hideFromCaseTrainer", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "hideReason", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "sentencesCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "hasSentences", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "wordAssociationCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "maxFrequencyRanking", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "gender", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "plural", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "wordTypeId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "rootWordTypeId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "blankSource", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "levelId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "label", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "targetText", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "alternateTargetText", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "targetId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "inlineTargetText", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "autoLevel", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "wordAssociationId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "ignoreAutoLevel", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "simple", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "root", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "isPrefix", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "isStem", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "isDate", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "rootId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "excludeFromPublicLists", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "excludeAsPluralForm", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "sourcesCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "enSourcesCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "cardsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "noPlural", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "pendingApproval", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "submittedById", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "commentsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "forumThreadId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "rootWordId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "rootWordGender", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "useParenthesesOnGender", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "frequencyRanking", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "frequencyWordTypeRanking", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "frequencyScore", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "frequencyRanking1", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "frequencyRanking2", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "frequencyRanking3", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "frequencyScoreAdjustment", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "falsePlurals", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "pluralOptions", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "invalidGender", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "hasAdjectiveForm", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "note", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "tag", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "allowDuplicateRoots", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "articleHasApostrophe", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "articleTakesOppositeGender", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "articleIsHidden", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "needsSecondaryVideo", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "conjugatedVerbStringsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "conjugationPreview", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "vocabTriadConceptId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "vocabTriadDeckId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "feminineGenderVariant", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "masculineGenderVariant", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "normalizedTargetText", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "vocabListSentencesCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "hasVocabListSentences", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "viewsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "learned", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "reviewing", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "userTranslationId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "consecutiveGoodScores", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class.prototype, "treePosition", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor82 = _applyDecoratedDescriptor(_class.prototype, "register", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor83 = _applyDecoratedDescriptor(_class.prototype, "hasDictionaryConcept", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor84 = _applyDecoratedDescriptor(_class.prototype, "singularArticle", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor85 = _applyDecoratedDescriptor(_class.prototype, "pluralArticle", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor86 = _applyDecoratedDescriptor(_class.prototype, "definition", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor87 = _applyDecoratedDescriptor(_class.prototype, "synonymsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor88 = _applyDecoratedDescriptor(_class.prototype, "hasRelatedDictionaryWords", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor89 = _applyDecoratedDescriptor(_class.prototype, "hasDictionarySynonyms", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor90 = _applyDecoratedDescriptor(_class.prototype, "wordDerivationStemsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor91 = _applyDecoratedDescriptor(_class.prototype, "wordDerivationChildrenCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor92 = _applyDecoratedDescriptor(_class.prototype, "worksheetsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor93 = _applyDecoratedDescriptor(_class.prototype, "stressedCharacters", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor94 = _applyDecoratedDescriptor(_class.prototype, "falseMultipleChoiceOptions", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor95 = _applyDecoratedDescriptor(_class.prototype, "falseMultipleChoiceOptionsEn", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor96 = _applyDecoratedDescriptor(_class.prototype, "falseSynonyms", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor97 = _applyDecoratedDescriptor(_class.prototype, "falseMultipleChoiceOptionsJson", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor98 = _applyDecoratedDescriptor(_class.prototype, "falseMultipleChoiceOptionsLanguageId", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor99 = _applyDecoratedDescriptor(_class.prototype, "sourceLanguageIdsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor100 = _applyDecoratedDescriptor(_class.prototype, "aiLanguagesTranslated", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor101 = _applyDecoratedDescriptor(_class.prototype, "meaningsCount", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor102 = _applyDecoratedDescriptor(_class.prototype, "meaningsReviewed", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor103 = _applyDecoratedDescriptor(_class.prototype, "childWordsList", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor104 = _applyDecoratedDescriptor(_class.prototype, "skipConjugationGeneration", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor105 = _applyDecoratedDescriptor(_class.prototype, "batchCreateInput", [_serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor106 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor107 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor108 = _applyDecoratedDescriptor(_class.prototype, "target", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor109 = _applyDecoratedDescriptor(_class.prototype, "level", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor110 = _applyDecoratedDescriptor(_class.prototype, "createdByUser", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor111 = _applyDecoratedDescriptor(_class.prototype, "rootWord", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor112 = _applyDecoratedDescriptor(_class.prototype, "genderVariant", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor113 = _applyDecoratedDescriptor(_class.prototype, "minimalPair", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor114 = _applyDecoratedDescriptor(_class.prototype, "prefix", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor115 = _applyDecoratedDescriptor(_class.prototype, "childWords", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor116 = _applyDecoratedDescriptor(_class.prototype, "pluralNouns", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor117 = _applyDecoratedDescriptor(_class.prototype, "conjugatedVerbStrings", [_mobx.observable, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor118 = _applyDecoratedDescriptor(_class.prototype, "stems", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor119 = _applyDecoratedDescriptor(_class.prototype, "concepts", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor120 = _applyDecoratedDescriptor(_class.prototype, "sources", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor121 = _applyDecoratedDescriptor(_class.prototype, "wordStructures", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor122 = _applyDecoratedDescriptor(_class.prototype, "synonyms", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor123 = _applyDecoratedDescriptor(_class.prototype, "synonymAssociations", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor124 = _applyDecoratedDescriptor(_class.prototype, "wordDerivationStems", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor125 = _applyDecoratedDescriptor(_class.prototype, "wordDerivationChildren", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor126 = _applyDecoratedDescriptor(_class.prototype, "translationSources", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor127 = _applyDecoratedDescriptor(_class.prototype, "meaningSourcePreviews", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor128 = _applyDecoratedDescriptor(_class.prototype, "worksheets", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor129 = _applyDecoratedDescriptor(_class.prototype, "meanings", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor130 = _applyDecoratedDescriptor(_class.prototype, "wordType", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor131 = _applyDecoratedDescriptor(_class.prototype, "rootWordType", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _class);
var _default = exports["default"] = Word;